<template>
  <div>
    <Introduce />
    <Categories />
    <!-- 返回旧版 -->
    <div class="backlog">
      <a href="/wiki" style="color: rgba(0, 0, 0, 0.65)">
      <p>返回旧版</p></a>
    </div>
  </div>
</template>

<script>
import Introduce from "@/views/introduce.vue";
import Categories from "@/views/categories.vue";

export default {
  name: "Home",
  components: {
    Introduce,
    Categories,
  },
  methods:{
  }
};
</script>
<style scoped>
.backlog {
  position: fixed;
  z-index: 999;
  width: 38px;
  padding: 8px;
  height: 104px;
  background: #ffffff;
  right: 0;
  top: 50%;
  border-style: solid;
  border-color: #ececec;
  /* 弹窗阴影 */
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px 0px 0px 4px;
  font-weight: 400;
font-size: 14px;
line-height: 22px;
}
</style>
